<template>
  <div class="position-relative">
    <ejs-grid
      v-show="!showLoader"
      ref="dataGrid"
      :created="refreshGrid"
      :allowPaging="true"
      :allowSorting="true"
      :pageSettings="pageSettings"
      :toolbar="toolbar"
      :searchSettings="search"
      :allowExcelExport="true"
      :allowPdfExport="true"
      :toolbarClick="toolbarClick"
      :locale="usedLang"
      :rowSelected="rowSelected"
      :dataSource="pendingRequest"
    >
      <e-columns>
        <!-- <e-column field="index" width="40" headerText="#"></e-column> -->

        <e-column
          field="orderDate"
          width="150"
          :headerText="$t('text.retainership.orderDate')"
        ></e-column>

        <e-column
          field="orderBy"
          width="200"
          :headerText="$t('text.products.name')"
        ></e-column>

        <e-column
          field="quantity"
          width="150"
          :headerText="$t('text.cInvoice.details.quantity')"
        ></e-column>

        <e-column
          field="orderAmount"
          width="150"
          :headerText="$t('text.retainership.orderAmount')"
        ></e-column>

        <e-column
          field="state"
          width="180"
          :headerText="$t('text.form.state')"
        ></e-column>
        <e-column
          field="address"
          width="200"
          :headerText="$t('text.form.address')"
        ></e-column>
      </e-columns>
    </ejs-grid>
    <TableLoader :showLoader="showLoader" />
    <!-- <DropDown :details="details" /> -->
  </div>
</template>

<script>
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

import TableLoader from "@/components/tableLoader/index";

export default {
  name: "PendingClientRequest",
  props: ["pendingRequest", "showLoader"],
  components: {
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },

  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
    };
  },

  methods: {
    //Utilities
    rowSelected(args) {
      //redirect to approval page
      this.$router.push({
        name: "approve-retainership-card-request",
        query: {
          companyId: this.$route.query.companyId,
          requestId: args.data.id,
        },
      });
    },

    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },

    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
  },
};
</script>

<style>
</style>